// 1) Laufzeit-ENV aus dem Container (hat höchste Priorität)
// 2) Build-ENV aus Vite (.env, .env.staging, .env.production) – nur zur Build-Zeit
// 3) Einheitliche zentrale Base-URL mit deiner Priorität
export const getEnv = (key: string, fallback?: string) =>
  (window as any).__ENV__?.[key] ?? (import.meta as any).env?.[key] ?? fallback ?? '';
